require('./angular-touch');
module.exports = 'ngTouch';



//////////////////
// WEBPACK FOOTER
// /Users/shakyshane/Sites/oss/UI/~/angular-touch/index.js
// module id = 8
// module chunks = 0